export function fetchVideoAndNoteList() {
  let url = "https://bibdorm.bsb-muenchen.de";
  return fetch(url + "/BV042012027/public/fleischmann_object.json", {
    method: "POST",
  })
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      for (let entry of result) {
        entry["url-video"] = url + entry["url-video"];
        entry["url-foto"] = url + entry["url-foto"];
      }

      return result;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
